export const IMAGE_FILE_EXTENSIONS = ['jpg', 'png', 'webp'];
export const VIDEO_FILE_EXTENSIONS = ['mp4', '3gp', 'ogg'];
